<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="12">
        <el-form
          label-position="top"
          label-width="200px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>全球分红</h3>
          <div>
            <el-row type="flex" justify="center">
              <el-col>
                <h3 class="text-center">VIP 1 - 5 的奖金权重</h3>
              </el-col>
            </el-row>

            <el-table
              :data="form.vip_bonus_configs"
              border
              style="width: 100%"
              @cell-mouse-enter="handleCellEnter"
              @cell-mouse-leave="handleCellLeave"
            >
              <el-table-column prop="date" label="VIP等级" width="170">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="奖励比例">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.share"
                    placeholder="请输入1-100正整数"
                  >
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-row type="flex" justify="center">
              <el-col>
                <h3 class="text-center">VIP6 - Super VIP的奖金权重</h3>
              </el-col>
            </el-row>

            <el-table
              :data="form.super_vip_bonus_configs"
              border
              style="width: 100%"
              @cell-mouse-enter="handleCellEnter"
              @cell-mouse-leave="handleCellLeave"
            >
              <el-table-column prop="date" label="VIP等级" width="170">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="奖励比例">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.share"
                    placeholder="请输入1-100正整数"
                  >
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <h3>
            <el-col>
              <el-row type="flex" justify="center">
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="saveConfigs"
                    :loading="btnLoading"
                  >
                    保存
                  </el-button>
                </el-form-item>
              </el-row>
            </el-col>
          </h3>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      btnLoading: false,
      rules: {
        welfare_bonus_effective_child_nodes_reward_money: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
      },
      form: {
        vip_bonus_configs: [],
        super_vip_bonus_configs: [],
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    /** 鼠标移入cell */
    handleCellEnter(row, column, cell, event) {
      row.isEdit = true
    },
    /** 鼠标移出cell */
    handleCellLeave(row, column, cell, event) {
      row.isEdit = false
    },
    configs() {
      request({
        url: '/api/backend/rewardConfig/globalBonusConfigs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
          console.log(this.form)
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveGlobalBonusConfigs',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
.text-center {
  text-align: center;
}
</style>
